import { useContext } from "react";
import useApi from "../hooks/useApi";
import { HotelContext } from "../context/hotel";
import { CheckInContext } from "../context/checkin";


const usePerson = () => {
    const { get, post } = useApi();
    const { data } = useContext(HotelContext);

    const getReservations = async (personId) => {
        try {
            const response = await get(`hotels/${data.id}/public/persons/${personId}`);
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    };

    const getRequest = async (requestId) => {
        try {
            const response = await get(`hotels/${data.id}/public/requests/${requestId}`);
            return response;
        } catch (error) {
            throw error;
        }
    };

    const addPublicRequestComment = async (requestId, comment) => {
        try {
            const response = await post(`hotels/${data.id}/public/requests/${requestId}/comments`, { "comment": comment });
            return response;
        } catch (error) {
            throw error;
        }
    };

    return {
        getReservations,
        getRequest,
        addPublicRequestComment
    };
};

export default usePerson;
